<template>
	<div :class="$style.Fycenter">
		<div :class="$style.Fyheader">
			<img src="../assets/payment_FPS.png" alt="" style="width: 50px;height: 50px;">
		</div>
		<p style="margin: 20px 0;">{{ $t('fpsH') }}</p>
		<p :class="$style.fmar">{{ $t('fpsT') }}</p>
		<p :class="$style.fmar" style="color: #F2994A;text-decoration: underline;">{{ $t('fps1') }}</p>
		<p :class="$style.fmar">{{ $t('fps2') }}</p>
		<p :class="$style.fmar" style="color: #F2994A;text-decoration: underline;">{{ $t('fps3') }}</p>
		<p :class="$style.fmar">{{ $t('fps4') }}</p>
		<p :class="$style.fmar" style="color: #F2994A;text-decoration: underline;">{{ $t('fps5') }}</p>
		<p :class="$style.fmar">{{ $t('fps6') }}</p>
	</div>
</template>

<script>
export default {
    name: 'fps',
    props: {
        
    },
    data() {
        return {
            
        }
    },
    watch: {
        
    }
}		
</script>

<style module>
.Fycenter {
	width: 40.625rem;
	height: 21.25rem;
	background-color: #FDF6EC;
	text-align: center;
	margin: 1.25rem auto;
	padding-top: 0.625rem;
}
.Fyheader {
	margin: 0.625rem 0;
}
.fmar{
	margin: 0.3125rem 0;
}
@media screen and (max-width: 770px) {
	.Fycenter {
		width: 20.625rem;
		height: 21.25rem;
		background-color: #FDF6EC;
		text-align: center;
		margin: 1.25rem auto;
		padding-top: 0.625rem;
	}
}
</style>
